<template>
  <Dialog ref="dialog" type="confirm" :show="$bus.confirmDialog.show">
    <template v-slot:dialog-content>
      <p class="confirm-tip" v-html="getText"></p>
      <div class="confirm-notice" @click="notice = !notice">
        <span class="notice-checkbox">
          <i class="checkbox-right" v-show="!notice"/>
        </span>
        <span class="notice-text">{{$bus.transify['POPUP_NO_REMIND']}}</span>
      </div>
      <ff-button type="confirm" @btnEvent="handleConfirm">
        <span class="confirm-btn-text">{{$bus.transify['FLIP_CONFIRM']}}</span>
      </ff-button>
    </template>
  </Dialog>
</template>

<script>
import ffButton from '@/components/common/Button.vue'
import Dialog from '@/components/common/Dialog.vue'
export default {
  components: {
    ffButton,
    Dialog
  },
  data () {
    return {
      notice: true
    }
  },
  computed: {
    getText () {
      const type = this.$bus.confirmDialog.type || ''
      switch (type) {
         case 'flip':
          this.initNotice(this.$bus.flipNotice)
          return this.replaceText(this.$bus.transify['FLIP_GEM_CONFIRM'],
                  '{gem num}',
                  `<span style="font-size: 1.3em; color: #FFDE00; font-weight: 500;">${this.$bus.nowPrice}</span>`)
        case 'refresh':
          this.initNotice(this.$bus.refreshNotice)
          return this.replaceText(this.$bus.transify['FLIP_REFRESH_DBCHECK'],
                  '{cost}',
                  `<span style="font-size: 1.3em; color: #FFDE00; font-weight: 500;">${this.$bus.actInfo.refreshCost}</span>`)
        default:
          return ''
      }
    }
  },
  methods: {
    replaceText (text, source, target) {
      if (text && text.indexOf(source) > -1) {
        return text.replace(source, `${target}`)
      } else {
        return text
      }
    },
    handleConfirm () {
      const type = this.$bus.confirmDialog.type
      switch (type) {
        case 'flip':
          if (!this.notice) {
            this.$bus.flipNotice = this.notice
            localStorage.setItem(`${PROJECT_NAME}_${type}_${this.$bus.uid}`, this.$bus.flipNotice)
          }
          this.$bus.flip()
          break
        case 'refresh':
          const refreshCost = this.$bus.actInfo.refreshCost
          if (!this.notice) {
            this.$bus.refreshNotice = this.notice
            localStorage.setItem(`${PROJECT_NAME}_${type}_${this.$bus.uid}`, this.$bus.refreshNotice)
          }
          this.$bus.refresh(refreshCost)
          break
        default:
          break
      }
      this.notice = true
      this.$bus.confirmDialog.show = false
      this.$bus.addGA(`${type}_close_notice`, 'true')
    },
    initNotice (bool) {
      this.notice = bool
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-btn-text {
  flex: auto;
  @include px2res(height, 60);
  @include px2res(line-height, 66);
}
.confirm-tip {
  max-width: 74%;
  margin: 0 auto;
  text-align: center;
  line-height: 1;
  @include px2res(font-size, 44);
  font-style: italic;
  color: #FFDBA7;
}
.confirm-notice {
  @include flexrc;
  @include px2res(margin, 25, auto, 20);
  .notice-checkbox {
    position: relative;
    @include px2res(width, 36);
    @include px2res(height, 36);
    @include px2res(margin-right, 22);
    background-color: #000;
    background-size: 98% auto;
    .checkbox-right {
      position: absolute;
      @include px2res(bottom, 3);
      @include px2res(left, 0);
      @include px2res(width, 45);
      @include px2res(height, 43);
      background-size: 98% auto;
    }
  }
  .notice-text {
    @include px2res(font-size, 30);
    @include px2res(height, 36);
    @include px2res(line-height, 42);
    color: #FFF7E1;
    white-space: nowrap;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/confirm/index.vue